import React, { useContext } from "react";
//
import Tooltip from "@mui/material/Tooltip";
import IconEvent from "../../../../../../images/icon_event_dark/Mask Group 87.svg";
import Act from "../../../../../store/actions";
import { StoreContext } from "../../../../../store/StoreProvider";
import IconButtonGen from "../../../../../common/components/iconButton/IconButtonGen";

const DiaryInfoIconTool = () => {
  const [_, dispatch] = useContext(StoreContext);

  return (
    <div>
      <IconButtonGen
        onClick={() => {
          dispatch({
            type: Act.SNA_DIARY_INFO_DISPLAY_WINDOW,
            payload: true,
          });
        }}
        iconSrc={IconEvent}
        iconAlt="icon event"
        variant="square"
        sx={{
          "&.MuiIconButton-root": {
            backgroundColor: "#e6e9ef",
            boxShadow: "",
          },
        }}
        toolTipTitle="日誌事件"
        tooltipPlacement="left"
      />
    </div>
  );
};

export default DiaryInfoIconTool;
